import { useTheme as muiUseTheme } from "@mui/system";

import { default as THEME } from "./theme";

export { default as BackpackThemeProvider } from "./ThemeProvider";
export { THEME };
export type Theme = typeof THEME;

export const useTheme = () => muiUseTheme<Theme>();
